﻿interface ActivityItem {
  id: string;
  usuario: string;
  accion: string;
  tiempo: string;
  avatar: string;
}

const avatarColors = ["bg-blue-500", "bg-emerald-500", "bg-violet-500", "bg-amber-500", "bg-rose-500"];

interface ActividadPanelProps {
  items: ActivityItem[];
}

export default function ActividadPanel({ items }: ActividadPanelProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-800">Actividad Reciente</h3>
        <span className="text-xs text-blue-600">{items.length} eventos</span>
      </div>

      {items.length === 0 ? (
        <div className="p-6 text-sm text-gray-500 bg-gray-50 rounded-lg">Sin actividad reciente.</div>
      ) : (
        <div className="relative">
          <div className="absolute left-4 top-4 bottom-4 w-px bg-gray-100" />
          <div className="space-y-4">
            {items.map((item, index) => (
              <div key={item.id} className="flex items-start gap-3 relative">
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-white text-xs font-bold flex-shrink-0 z-10 ${avatarColors[index % avatarColors.length]}`}
                >
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <p className="text-sm text-gray-700 leading-snug">
                    <span className="font-medium">{item.usuario}</span>{" "}
                    <span className="text-gray-500">{item.accion}</span>
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">{item.tiempo}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
